import { useState, useEffect } from "react";
import AuthorizationINSSSection from "./components/AuthorizationINSSSection";
import { AUTHORIZATION_FIELDS } from "./components/authorizationFields";
import api from "../../api/axios";
import { Box, Button, Typography, Divider, Fade, Chip } from "@mui/material";
import { CommonSubHeader } from "../../Components/helpers/Helpers";
import Swal from "sweetalert2";
import { MenuBook } from "@mui/icons-material";
import LoadPdf from "../../Biblioteca/Crud/LoadPdf/LoadPdf";

const Settings = () => {
  const [authorizationFiles, setAuthorizationFiles] = useState({});
  const [existingFiles, setExistingFiles] = useState([]);
  const [changeDone, setChangeDone] = useState(false);
  const [flag, setFlag] = useState(false);

  const handleFileChange = (key, file) => {
    setAuthorizationFiles((prev) => ({
      ...prev,
      [key]: file,
    }));
  };

  const saveFiles = async () => {
    try {
      const formData = new FormData();

      Object.entries(authorizationFiles).forEach(([key, file]) => {
        if (file) {
          formData.append(key, file);
        }
      });

      Swal.fire({
        title: "Guardando...",
        text: "Subiendo archivos",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      await api.post("/caseconfigdocuments/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      Swal.close();

      Swal.fire({
        icon: "success",
        title: "Guardado",
        timer: 2000,
        showConfirmButton: false,
      });

      setChangeDone((prev) => !prev);
      setAuthorizationFiles({});
    } catch (error) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Error al guardar",
      });
    }
  };

  const loadExistingFiles = async () => {
    try {
      const { data } = await api.get("/caseconfigdocuments/list");
      setExistingFiles(data);
      setFlag(true);
    } catch (error) {
      console.error(error);
    }
  };

  const getFilesByKey = (key) => {
    return existingFiles.filter((file) => file.name.startsWith(key));
  };

  const inssFile = getFilesByKey("inss_authorization")[0];
  const newInssFile = authorizationFiles["inss_authorization"];

  useEffect(() => {
    loadExistingFiles();
  }, [changeDone]);

  console.log(inssFile);

  return (
    <>
      <CommonSubHeader title="Configuración" subTitle="Expedientes" />

      <Fade in={flag} timeout={600}>
        <Box sx={{ maxWidth: "1000px", margin: "auto" }}>
          <Box
            sx={{
              background: "white",
              borderRadius: "12px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
              p: 3,
              mb: 3,
            }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Subir autorizaciones
            </Typography>

            <AuthorizationINSSSection
              fields={AUTHORIZATION_FIELDS}
              files={authorizationFiles}
              existingFiles={existingFiles}
              onFileChange={handleFileChange}
            />

            {/* NUEVO ARCHIVO */}
            {newInssFile && (
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: "#1b8f4c",
                  }}>
                  Nuevo archivo seleccionado:
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontWeight: 600,
                  }}>
                  {newInssFile.name}
                </Typography>
              </Box>
            )}

            <Box sx={{ mt: 2, display: "flex", justifyContent: "end" }}>
              <Button variant="contained" color="success" onClick={saveFiles}>
                Guardar autorizaciones
              </Button>
            </Box>
          </Box>
          {(inssFile || newInssFile) && (
            <Box
              sx={{
                background: "white",
                borderRadius: "12px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                p: 3,
                mb: 3,
              }}>
              {/*  ARCHIVO ACTUAL */}
              {inssFile && (
                <>
                  <Chip
                    icon={<MenuBook color="info" />}
                    label={`Actual: ${inssFile.name}`}
                    sx={{
                      mb: 1,
                      background: "#eef4ff",
                      color: "#2b5cff",
                      fontWeight: 600,
                    }}
                  />

                  <LoadPdf
                    bookName={inssFile.name}
                    bookId={inssFile.id || ""}
                    alternativeRute={"caseconfig/" + inssFile.name}
                  />
                </>
              )}
            </Box>
          )}
        </Box>
      </Fade>
    </>
  );
};

export default Settings;
